// extracted by mini-css-extract-plugin
export default {"arrowContainer":"ArrowBounce_arrowContainer__+lbBD","arrow":"ArrowBounce_arrow__uvK16","bounce":"ArrowBounce_bounce__jT6ci"};